import ReactDom from 'react-dom'
import React, { useEffect, useState } from 'react'

// Payment Libraries
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'

// Custom Imports
import { useAuth } from '../../../hooks/useAuth'
import { reservationService } from '../../../services/reservation.service'
import CheckoutForm from '../CheckoutForm'
import './style.scss'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_LIVE_KEY)

export const ModalReservation = ({ event, ticketCount, funcion, ticket }) => {
  // Client Secret de Stripe
  const [clientSecret, setClientSecret] = useState('')
  const [paymentIntent, setPaymentIntent] = useState('')
  const auth = useAuth()

  const reserva = {
    fecha_funcion: funcion.fecha_funcion,
    hora_inicio: funcion.hora_inicio,
    id_usuario: auth.user.uid,
    id_evento: event.eid,
    id_funcion: funcion.id_funcion_fk,
    id_boleto: ticket.bid,
    cantidad_boletos: parseInt(ticketCount),
    paymentIntent: paymentIntent
  }

  useEffect(() => {
    async function fetchData () {
      const data = await reservationService.createPaymentIntent(ticket.precio, ticketCount, event.eid)
      setPaymentIntent(data.paymentIntent.id)
      setClientSecret(data.clientSecret)
    }
    fetchData()
  }, [ticket, ticketCount])

  const appearance = {
    theme: 'stripe'
  }
  const options = {
    clientSecret,
    appearance
  }

  return ReactDom.createPortal(
    <div className="modal fade" id="modalReserve" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title text-dark" id="exampleModalLabel">Reserva de evento</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
          </div>
          <div className="modal-body">
            {clientSecret && (
              <Elements options={options} stripe={stripePromise} key={clientSecret}>
                <CheckoutForm reserva={reserva} paymentIntent={paymentIntent}/>
              </Elements>
            )}
          </div>
        </div>
      </div>
    </div>, document.getElementById('checkout')
  )
}
